import { Container } from 'inversify';

import { Configuration } from './configuration';

import { SavedBankAccountApiService } from './api/savedBankAccountApi.service'
import { ChargeApiService } from './api/chargeApi.service';
import { ClientDataApiService } from './api/clientDataApi.service';
import { ContactUsApiService } from './api/contactUsApi.service';
import { EstimatesApiService } from './api/estimatesApi.service';
import { FinancingAPIService } from './api/financing-bridgeAPI.service';
import { FormsApiService } from './api/formsApi.service';
import { HomeApiService } from './api/homeApi.service';
import { InvoicesApiService } from './api/invoicesApi.service';
import { JobsApiService } from './api/jobsApi.service';
import { LoansAPIService } from './api/loansAPI.service';
import { LogApiService } from './api/logApi.service';
import { LoginApiService } from './api/loginApi.service';
import { MarketingApiService } from './api/marketingApi.service';
import { MembershipsApiService } from './api/membershipsApi.service';
import { PayByBankApiService } from './api/payByBankApi.service';
import { PhoneCaptureApiService } from './api/phoneCaptureApi.service';
import { SavedCreditCardsApiService } from './api/savedCreditCardsApi.service';
import { SchedulerApiService } from './api/schedulerApi.service';
import { StatementsApiService } from './api/statementsApi.service';
import { VisitAssistantApiService } from './api/visitAssistantApi.service';

export const apiContainer = new Container();
apiContainer.bind(SavedBankAccountApiService).toSelf();
apiContainer.bind(ChargeApiService).toSelf();
apiContainer.bind(ClientDataApiService).toSelf();
apiContainer.bind(ContactUsApiService).toSelf();
apiContainer.bind(EstimatesApiService).toSelf();
apiContainer.bind(FinancingAPIService).toSelf();
apiContainer.bind(FormsApiService).toSelf();
apiContainer.bind(HomeApiService).toSelf();
apiContainer.bind(InvoicesApiService).toSelf();
apiContainer.bind(JobsApiService).toSelf();
apiContainer.bind(LoansAPIService).toSelf();
apiContainer.bind(LogApiService).toSelf();
apiContainer.bind(LoginApiService).toSelf();
apiContainer.bind(MarketingApiService).toSelf();
apiContainer.bind(MembershipsApiService).toSelf();
apiContainer.bind(PayByBankApiService).toSelf();
apiContainer.bind(PhoneCaptureApiService).toSelf();
apiContainer.bind(SavedCreditCardsApiService).toSelf();
apiContainer.bind(SchedulerApiService).toSelf();
apiContainer.bind(StatementsApiService).toSelf();
apiContainer.bind(VisitAssistantApiService).toSelf();
